export const GET_NOTIFICATION_NEWS_FAILED = "error:notification.get-notification-news-failed"
export const CLEAR_AND_UPDATE_NOTIFICATION_NEWS_FAILED = "error:notification.clear-and-update-notification-news-failed"
export const APPROVE_NOTIFICATION_FAILED = "error:notification.approve-notification-failed"
export const DELETE_NOTIFICATION_FAILED = "error:notification.delete-notification-failed"
